import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid2, FormGroup, FormControlLabel, Checkbox } from '@mui/material'

import CustomButton from '@components/button/customButton';
import CustomTextField from '@components/inputs/customTextField';

import { QUESTION_TYPE } from '@utils/constant';

export default function ViewFormDialog({
  open,
  onClose,
  formAnswers = [],
  // formListing = [],
}) {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" fontSize={"0.9rem"} fontWeight={600} color='#202020' sx={{padding: '20px 25px'}}>
        View Form
      </DialogTitle>
      <DialogContent sx={{padding: '0px 25px', overflow: 'visible', minHeight: '300px', maxHeight: '75vh', overflowY: 'scroll', }}>
        <Grid2 container spacing={"10px"} >
          {
            formAnswers ? 
              formAnswers.map((item, index) => (
                <React.Fragment key={index}>
                  <Grid2 size={12}>
                    <Typography fontSize={"0.8rem"} color="#5D5D5D" fontWeight={600} mt={'10px'}>{item?.question}</Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    {
                      item.answers.map((answer, index) => (
                        <React.Fragment key={index}>
                          <CustomTextField 
                            value={answer?.answer}
                            label="Answer"
                            readOnly
                            sx={{marginTop: '10px'}}
                          />
                          {answer.remark &&
                            <CustomTextField 
                              value={answer?.remark}
                              label="Sub Text"
                              readOnly
                              sx={{marginTop: '10px'}}
                            />
                          }
                        </React.Fragment>
                      ))
                    }
                    
                  </Grid2>
                </React.Fragment>
              ))
            : 
            <Grid2 size={12} sx={{backgroundColor: '#E5E5E5', padding: "20px 0px"}}>
              <Typography fontSize={"0.8rem"} color="#5D5D5D" fontWeight={600} textAlign={"center"}>No Form Questions</Typography>
            </Grid2>
          }
        </Grid2>
      </DialogContent>
      <DialogActions sx={{padding: '20px 25px'}}>
        <CustomButton color='#999999' onClick={onClose}>
          Close
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}